import { Icon } from "@circle-react-shared/Icon";
import { ComboboxButton } from "@headlessui/react-v2";
import classNames from "classnames";
import { forwardRef } from "react";

export interface ChevronDownButtonProps {
  className?: string;
}

export const ChevronDownButton = forwardRef<
  HTMLButtonElement,
  ChevronDownButtonProps
>(({ className }, ref) => (
  <ComboboxButton
    ref={ref}
    className={classNames(
      "text-dark absolute inset-y-0 right-0 flex items-center pr-2 disabled:!cursor-not-allowed disabled:!opacity-40",
      className,
    )}
  >
    <Icon type="20-chevron-down-sm" size={20} />
  </ComboboxButton>
));

ChevronDownButton.displayName = "ChevronDownButton";
